import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import LocaleSelector from 'vuecomponents/LocaleSelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideFooterOld',
  setup(__props) {

const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletPortrait, isBiggerThanTabletLandscape } = storeToRefs(windowSizeStore)

return { __sfc: true,windowSizeStore, isSmallerThanTabletPortrait, isBiggerThanTabletLandscape, LocaleSelector }
}

})